<template>
    <div>
        <MercenaryHeader :title="'개인정보'" :back-title="'활동 및 설정'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex:1; padding:12px; background-color: #f5f5f5;">
            <div style="color:#210F03; font-size: 16px; font-weight:500; margin-top:10px;">개인정보</div>
            <div style="margin-top:5px;font-size: 12px;line-height: 20px;color: #606060;">사커하우는 양질의 정보를 제공하는 커뮤니티를 유지하며 다른 회원관의 안전한 오프라인 활동을 할 수 있도록 돕기 위해 개인정보를 사용합니다. 또한 개인 맞춤형 피드를 제공하기 위해 일부 개인정보가 사용됩니다.</div>

            <div class="container" style="margin-top:20px;">
                <div>
                    <div class="label">이름</div>
                    <div class="contents">{{ member.name }}</div>
                </div>
                <div class="horizontal_line"></div>
                <div>
                    <div class="label">성별</div>
                    <div class="contents">{{ member.sex ? member.sex + '성' : '' }}</div>
                </div>
            </div>

            <div class="container">
                <div>
                    <div class="label">연락처 정보</div>
                    <div class="contents">{{ member.phone }}</div>
                </div>
            </div>

            <div class="container">
                <div>
                    <div class="label">생년월일</div>
                    <div class="contents">{{ member.birthday ? member.birthday.substr(0, 4) + '년 ' + parseInt(member.birthday.substr(5, 2)) + '월 ' + member.birthday.substr(8, 2) + '일' : '' }}</div>
                </div>
            </div>

            <div class="container" @click="() => { is_open_region_selector = true; flag_refresh = true; }">
                <div>
                    <div class="label">거주지역</div>
                    <div class="contents">{{ member.region_name }}</div>
                </div>
                <div class="horizontal_line" style=""></div>
                <div style="font-size:14px; font-weight:500; color:var(--color-main)">변경하기</div>
            </div>
        </div>

        <CommonPopupFrame :changeHeight="600" :change-height-unit="'px'" :changeBottom="0" :isOpen="is_open_region_selector" :closeCompleteAction="closePopup">
            <template v-if="flag_refresh">
                <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
                <div style="flex: 1; display:flex; flex-direction: column; overflow-y: scroll; padding: 12px; padding-top: 12px" @touchmove.stop="() => { }">
                    <div style="color:#808080; font-size:16px; font-weight:bold;" @click="closePopup">닫기</div>
                    <div style="padding:30px 0px;">
                        <div style="text-align:center; font-size:32px; font-weight:bold; color:#210F03;">거주지역 변경하기</div>
                        <div style="text-align:center; font-size:16px; color:#210F03; margin-top:20px;">거주하고 있는 지역을 변경할 수 있습니다.</div>
                    </div>
                    <div style="background-color: #f5f5f5; border-radius:12px; padding:12px;">
                        <RegionSearchSelectorVer2 :detect-select="detectRegionSelect"></RegionSearchSelectorVer2>
                    </div>
                </div>
                <div style="padding:12px;">
                    <div style="" class="save_btn" :class="[new_region_name ? 'active' : '']" @click="save">저장하기</div>
                </div>
            </template>
        </CommonPopupFrame>

    </div>
</template>

<script>
import CommonPopupFrame from './CommonPopupFrame';
import MercenaryHeader from "../../common/MercenaryHeader";
import RegionSearchSelectorVer2 from "../../common/RegionSearchSelectorVer2";
import ResponseCode from "../../../ResponseCode";
export default {
    name: "Privacy",
    components: { RegionSearchSelectorVer2, MercenaryHeader, CommonPopupFrame },
    data() {
        return {
            member: {},
            is_open_region_selector: false,
            new_region_name: '',
            flag_refresh: false,
        }
    },
    methods: {
        showPhoneEdit() {
            this.$GlobalStore.addModal('PhoneEdit', { completeAction: () => { this.member = this.$GlobalStore.loginInfo() } });
        },
        back() {
            this.$GlobalStore.closeLastModal()
        },
        async save() {
            const parameters = {};
            parameters.region_name = this.new_region_name;

            this.closePopup();

            const res = await this.$Axios.post('/api/profile/save', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                this.member = res.data.loginInfo;

            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        closePopup() {
            this.new_region_name = '';
            this.is_open_region_selector = false;
            setTimeout(() => {
                this.flag_refresh = false;
            }, 300)
        },
        detectRegionSelect(data) {
            if (data) {
                this.new_region_name = data.sido + ' ' + data.sigungu + ' ' + data.dong;
            } else {
                this.new_region_name = '';
            }
        }
    },
    created() {
        this.save = this.$Once(this.save);
        if (this.$Util.isShowDefaultSettings()) {
            return
        }
        this.saveEmail = this.$Once(this.saveEmail);

        this.member = this.$GlobalStore.loginInfo();
    }
}
</script>

<style scoped>
.container {
    background-color: white;
    border-radius: 12px;
    padding: 12px;
}

.label {
    font-size: 14px;
    font-weight: bold;
    color: #210F03
}

.contents {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #210F03;
}

.container+.container {
    margin-top: 10px;
}

.horizontal_line {
    height: 1px;
    background-color: #EBEBEB;
    margin: 12px 0px;
}

.save_btn {
    background-color: #f5f5f5;
    display: grid;
    place-items: center;
    border-radius: 12px;
    height: 48px;
    color: #D9D9D9;
}

.save_btn.active {
    color: #210F03;
}
</style>